/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "./api";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const submitTantEvent = /* GraphQL */ `mutation SubmitTantEvent($rawEvent: String!) {
  submitTantEvent(rawEvent: $rawEvent) {
    message
    success
    __typename
  }
}
` as GeneratedMutation<
  APITypes.SubmitTantEventMutationVariables,
  APITypes.SubmitTantEventMutation
>;
export const submitManualTantCorrection = /* GraphQL */ `mutation SubmitManualTantCorrection(
  $location: String
  $shipments: [Shipment]
  $reason: String
  $comment: String
) {
  submitManualTantCorrection(
    location: $location
    shipments: $shipments
    reason: $reason
    comment: $comment
  ) {
    status
    error {
      message
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.SubmitManualTantCorrectionMutationVariables,
  APITypes.SubmitManualTantCorrectionMutation
>;
export const requestDivertFromUkUploadUrl = /* GraphQL */ `mutation RequestDivertFromUkUploadUrl {
  requestDivertFromUkUploadUrl {
    uploadUrl
    fileId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.RequestDivertFromUkUploadUrlMutationVariables,
  APITypes.RequestDivertFromUkUploadUrlMutation
>;
export const triggerProcessDivertFromUkFile = /* GraphQL */ `mutation TriggerProcessDivertFromUkFile($fileId: String!) {
  triggerProcessDivertFromUkFile(fileId: $fileId) {
    message
    success
    __typename
  }
}
` as GeneratedMutation<
  APITypes.TriggerProcessDivertFromUkFileMutationVariables,
  APITypes.TriggerProcessDivertFromUkFileMutation
>;
